import BaseCellText from 'common/components/table/base-cell-text';
import { ICellRendererProps } from 'common/components/table/table.types';
import { OperationType, operationTypeMap, SyncStatus, syncStatusMap } from 'features/eiq-manage/enums/integration-event.enum';
import { IIntegrationEvent } from 'features/eiq-manage/service/integration-events-service/integration-events.service.types';
import { IntegrationEventPayloadModal } from './integration-event-payload-modal/integration-event-payload-modal';

export const integrationEventsTableInitialColumns = [
  {
    key: 'integrationType',
    title: 'Integration Type',
    dataKey: 'integrationType',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'payload',
    title: 'Payload',
    dataKey: 'payload',
    width: 200,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IIntegrationEvent>) => {
      return cell.cellData && <IntegrationEventPayloadModal payload={cell.cellData} />;
    },
  },
  {
    key: 'operation',
    title: 'Operation',
    dataKey: 'operation',
    width: 120,
    minWidth: 120,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IIntegrationEvent>) => {
      return <BaseCellText>{operationTypeMap[cell.cellData as OperationType]}</BaseCellText>;
    },
  },
  {
    key: 'status',
    title: 'Status',
    dataKey: 'status',
    width: 120,
    minWidth: 120,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IIntegrationEvent>) => {
      return <BaseCellText>{syncStatusMap[cell.cellData as SyncStatus]}</BaseCellText>;
    },
  },
  {
    key: 'retryCount',
    title: 'Retry Count',
    dataKey: 'retryCount',
    width: 140,
    minWidth: 140,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'enqueuedAt',
    title: 'Enqueued At',
    dataKey: 'enqueuedAt',
    width: 300,
    minWidth: 300,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'lastRetryAt',
    title: 'Last Retry At',
    dataKey: 'lastRetryAt',
    width: 300,
    minWidth: 300,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'nextAttemptAt',
    title: 'Next Attempt At',
    dataKey: 'nextAttemptAt',
    width: 300,
    minWidth: 300,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'errorMessage',
    title: 'Error Message',
    dataKey: 'errorMessage',
    width: 350,
    minWidth: 350,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
  {
    key: 'groupKey',
    title: 'Group Key',
    dataKey: 'groupKey',
    width: 150,
    minWidth: 150,
    resizable: true,
    sortable: true,
    flexGrow: 1,
  },
];
